import { BORDER_WIDTH_TOKEN_KEYS } from '../tokens/border-widths';
import { SEMANTIC_COLOR_TOKEN_KEYS } from '../semantic/colors';
import { TYPOGRAPHY_FONT_SIZE_KEYS } from '../tokens/typography';
export const BUTTON_VARIANTS = Object.freeze([
    'primary',
    'secondary',
    'ghost',
    'outline',
    'destructive',
    'ghostDestructive',
]);
export const BUTTON_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const BUTTON_ICONS = Object.freeze(['icon-left', 'icon-right', 'icon-both', 'only-icon']);
export const BUTTON_SPINNER_PLACEMENTS = Object.freeze(['start', 'end']);
export const BUTTON_GROUP_ORIENTATIONS = Object.freeze(['horizontal', 'vertical']);
export const FORM_ORIENTATIONS = BUTTON_GROUP_ORIENTATIONS;
export const FIELD_INDICATORS = Object.freeze(['required', 'optional', 'none']);
export const CONTROL_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const COMPOSER_STATUSES = Object.freeze(['idle', 'running']);
export const COMPOSER_SUBMIT_MODES = Object.freeze(['enter', 'modEnter', 'none']);
export const STREAMING_TEXT_STATUSES = Object.freeze(['streaming', 'complete']);
export const STREAMING_TEXT_SEGMENT_KINDS = Object.freeze(['text', 'code']);
export const MESSAGE_PAIR_USER_VARIANTS = Object.freeze(['bubble', 'plain']);
export const TOOL_CALL_STATES = Object.freeze(['pending', 'running', 'completed', 'failed']);
export const SPINNER_SIZES = Object.freeze(['xs', 'sm', 'md', 'lg', 'xl']);
export const NAV_TREE_MAX_LEVEL = 12;
export const NAV_TREE_LEVELS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
export const BREADCRUMB_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const BREADCRUMB_VARIANTS = Object.freeze(['plain', 'underline']);
export const CHECKBOX_VARIANTS = Object.freeze(['solid', 'subtle', 'outline']);
export const CHECKBOX_LABEL_POSITIONS = Object.freeze(['start', 'end']);
export const SEGMENTED_CONTROL_VARIANTS = Object.freeze(['default', 'colored']);
export const SEGMENTED_CONTROL_ITEM_CONTENTS = Object.freeze(['text', 'icon', 'iconText']);
export const SEGMENTED_CONTROL_LAYOUTS = Object.freeze(['hug', 'fill']);
export const CODE_SIZES = Object.freeze(['xs', 'sm', 'md', 'lg']);
export const INPUT_VARIANTS = Object.freeze(['outline', 'filled', 'flushed']);
export const FOCUS_RING_PLACEMENTS = Object.freeze(['outside', 'inside', 'mixed', 'none']);
export const SELECT_VARIANTS = Object.freeze(['outline', 'filled', 'flushed', 'ghost']);
export const FLYOUT_PLACEMENTS = Object.freeze(['bottom', 'top']);
export const FLYOUT_ITEM_STATES = Object.freeze(['default', 'pressed', 'selected']);
export const DROPDOWN_MENU_PLACEMENTS = Object.freeze(['bottom', 'top', 'right', 'left']);
export const DROPDOWN_MENU_ALIGNS = Object.freeze(['start', 'center', 'end']);
export const DROPDOWN_MENU_POSITION_STRATEGIES = Object.freeze(['absolute', 'fixed']);
export const MODAL_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const MODAL_PLACEMENTS = Object.freeze(['center', 'top']);
export const MODAL_SCROLL_BEHAVIORS = Object.freeze(['inside', 'outside']);
export const MODAL_ROLES = Object.freeze(['dialog', 'alertdialog']);
export const TABLE_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const TABLE_VARIANTS = Object.freeze(['line', 'outline']);
export const TABLE_LAYOUTS = Object.freeze(['auto', 'fixed']);
export const TABLE_CAPTION_SIDES = Object.freeze(['top', 'bottom']);
export const TABLE_HEADER_SCOPES = Object.freeze(['col', 'row', 'colgroup', 'rowgroup']);
export const TABLE_STICKY_POSITIONS = Object.freeze(['start', 'end']);
export const CHART_KINDS = Object.freeze(['bar', 'line', 'pie']);
/** Runtime and declarative bounds shared by every maintained Chart implementation. */
export const CHART_MAX_DATASETS = 4;
export const CHART_MAX_POINTS = 32;
export const ACCORDION_SIZES = Object.freeze(['sm', 'md', 'lg']);
export const ACCORDION_VARIANTS = Object.freeze(['outline', 'subtle', 'enclosed', 'plain']);
export const STACK_DIRECTIONS = Object.freeze(['row', 'column', 'row-reverse', 'column-reverse']);
export const STACK_GAPS = Object.freeze(['none', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl']);
export const STACK_ALIGNMENTS = Object.freeze(['start', 'center', 'end', 'stretch']);
export const STACK_JUSTIFICATIONS = Object.freeze([
    'start',
    'center',
    'end',
    'between',
    'around',
    'evenly',
]);
export const TEXT_SIZES = TYPOGRAPHY_FONT_SIZE_KEYS;
export const FONT_WEIGHTS = Object.freeze([
    'thin',
    'light',
    'normal',
    'medium',
    'semibold',
    'bold',
    'extrabold',
]);
export const TEXT_RECIPE_WEIGHTS = Object.freeze([
    'thin',
    'light',
    'normal',
    'medium',
    'semibold',
    'bold',
    'extrabold',
]);
export const TEXT_RECIPE_COLORS = Object.freeze([
    'default',
    'subtle',
    'disabled',
    'inverse',
    'accent',
    'error',
    'success',
    'warning',
]);
export const LAYOUT_ALIGNMENTS = Object.freeze(['start', 'center', 'end', 'stretch', 'baseline']);
export const DIVIDER_ORIENTATIONS = Object.freeze(['horizontal', 'vertical']);
export const DIVIDER_VARIANTS = Object.freeze(['solid', 'dashed', 'dotted']);
export const DIVIDER_SIZES = BORDER_WIDTH_TOKEN_KEYS;
export const DIVIDER_COLORS = Object.freeze(SEMANTIC_COLOR_TOKEN_KEYS.map((value) => value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()).sort());
export const SCROLL_AREA_ORIENTATIONS = Object.freeze(['vertical', 'horizontal', 'both']);
export const SCROLL_AREA_VARIANTS = Object.freeze(['hover', 'always']);
export const SCROLL_AREA_SCROLLBARS = Object.freeze(['auto', 'hidden']);
export const SCROLL_AREA_SIZES = Object.freeze(['xs', 'sm', 'md', 'lg']);
export const SCROLL_AREA_GUTTERS = Object.freeze(['overlay', 'stable', 'stable-both-edges']);
export const TEXT_ALIGNMENTS = Object.freeze(['left', 'center', 'right', 'justify']);
export const HEADING_LEVELS = Object.freeze([1, 2, 3, 4, 5, 6]);
export const INPUT_TYPES = Object.freeze([
    'text',
    'email',
    'password',
    'number',
    'tel',
    'url',
    'search',
    'datetime-local',
]);
export const ALERT_VARIANTS = Object.freeze(['info', 'success', 'warning', 'error']);
export const TOAST_STATUSES = Object.freeze(['default', 'success', 'info', 'warning', 'error', 'loading']);
export const TOAST_ICON_STYLES = Object.freeze(['outline', 'filled']);
export const TOAST_POSITIONS = Object.freeze([
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
]);
export const CODE_VARIANTS = Object.freeze(['solid', 'subtle', 'outline', 'surface', 'plain']);
export const CODE_RECIPE_COLORS = Object.freeze([
    'default',
    'info',
    'success',
    'warning',
    'error',
]);
export const LINK_UNDERLINES = Object.freeze(['always', 'hover', 'none']);
export const TEXTAREA_RESIZES = Object.freeze(['none', 'vertical', 'horizontal', 'both']);
export const TABS_VARIANTS = Object.freeze(['line', 'subtle', 'outline']);
export const TABS_ORIENTATIONS = Object.freeze(['horizontal', 'vertical']);
export const TABS_ACTIVATION_MODES = Object.freeze(['automatic', 'manual']);
//# sourceMappingURL=component-vocabulary.js.map